"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserFillInBlanksComponentParameters = void 0;
exports.UserFillInBlanksComponentParameters = [
    {
        id: 'template',
        label: 'Template',
        description: 'Input Param - Template sentence with placeholders (e.g., "__1__", "__2__") to be filled in.',
        type: 'string',
        paramType: 'STRING',
        required: true,
    },
    {
        id: 'output',
        label: 'Output',
        description: 'Output Param - Captures the final sentence after user input replaces placeholders.',
        type: 'output',
        paramType: 'STRING',
        required: true,
    },
    {
        id: 'type',
        label: 'Type',
        description: 'Input Param - Specifies the type of input (e.g., TEXT, INTEGER, FLOAT).',
        type: 'enum',
        paramType: 'ENUM',
        list: {
            TEXT: 'Text',
            INTEGER: 'Integer',
            FLOAT: 'Float',
        },
        required: false,
    },
    {
        id: 'editDeltaMax',
        label: 'Max edit delta',
        description: 'Input Param - Maximum number of characters the text may change from the original.',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'minMax',
        label: 'Min-Max Constraints',
        description: 'Input Param - Specifies minimum and maximum constraints for numeric inputs. Example: [{"min": 0, "max": 23}, {"min": 0, "max": 59}]',
        type: 'json_array',
        paramType: 'ARRAY',
        required: false,
    },
    {
        id: 'regularExpression',
        label: 'Regular Expression',
        description: 'Input Param - Optional regex to validate user input.',
        type: 'string',
        paramType: 'STRING',
        required: false,
    },
    {
        id: 'errorMessage',
        label: 'Error Message',
        description: 'Input Param - Error message displayed if user input fails validation.',
        type: 'string',
        paramType: 'STRING',
        required: false,
    },
    {
        id: 'isDeltaExceeded',
        label: 'Is delta exceeded',
        description: 'Output Param - True when the edit exceeds max edit delta.',
        type: 'output',
        paramType: 'BOOLEAN',
        required: false,
    },
];
//# sourceMappingURL=UserFullInBlanksComponent.js.map